import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState, { MapLocationEntity } from "./state";
import { DroneStatusType, DroneEntity } from "@src/core/features";

const slice = createSlice({
  name: 'DronePageReducer',
  initialState,
  reducers: {
    resetState: () => initialState,
    setSelectedDrone: (state, action: PayloadAction<DroneEntity | null>) => {
      state.selectedDrone = action.payload;
      // Clear missionId when drone is deselected or changed
      if (!action.payload) {
        state.missionId = undefined;
      }
    },
    toggleCollapse: (
      state,
      action: PayloadAction<Extract<DroneStatusType, 'IDLE' | 'MISSION'>>
    ) => {
      const status = action.payload;
      state.collapse[status] = !state.collapse[status];
    },
    setMapLocation: (state, action: PayloadAction<MapLocationEntity>) => {
      state.location = action.payload;
    },
    resetMapLocation: (state) => {
      state.location = undefined;
    },
    setShowTakeoffConfirm: (state, action: PayloadAction<boolean>) => {
      state.showTakeoffConfirm = action.payload;
    },
    setMissionId: (state, action: PayloadAction<string | undefined>) => {
      state.missionId = action.payload;
    },
    setHoveredDrone: (state, action: PayloadAction<DroneEntity | null>) => {
      state.hoveredDrone = action.payload;
    },
    setManualControl: (
      state,
      action: PayloadAction<{ serialNumber: string; isManualControl: boolean }>
    ) => {
      state.manualControl[action.payload.serialNumber] = action.payload.isManualControl;
    },
  },
});

export default slice;

